
/* AMONAX XDB Pre-order Confirmation v3 */
(() => {
  if (window.__xdbPreorderV3) return;
  window.__xdbPreorderV3 = true;

  let pendingForm = null;
  let pendingId = null;
  let approvedForm = null;
  let previousFocus = null;
  let oldOverflow = "";

  const $ = selector => document.querySelector(selector);

  const modalSelector = '[id^="xdb-preorder-modal-"]';
  const variantsSelector = '[id^="xdb-preorder-variants-"]';

  function getModal() {
    return $(modalSelector);
  }

  function getVariants() {
    const node = $(variantsSelector);
    if (!node) return [];

    try {
      const data = JSON.parse(node.textContent);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error("XDB: Invalid variant JSON", error);
      return [];
    }
  }

  function preorderConfig() {
    try { return JSON.parse(document.querySelector('[id^="xdb-preorder-config-"]')?.textContent || '[]'); } catch { return []; }
  }
  function preorderForId(id) {
    return preorderConfig().find(v => String(v.id) === String(id));
  }
  function weightFromText(text) {
    const match = String(text || "").match(/\b(20|36|45)\s*kg\b/i);
    return match ? Number(match[1]) : null;
  }

  function getSelection(form) {
    const input = form.querySelector('input[name="id"]');
    const actualId = String(input?.value || "");

    const variants = getVariants();

    const actualVariant = variants.find(
      variant => String(variant.id) === actualId
    );

    // The custom variant cards provide a second check.
    const selectedCard = document.querySelector(
      '.amonax-db-weight-card[aria-pressed="true"]'
    );

    const visibleWeight = selectedCard
      ? weightFromText(
          selectedCard.dataset.weight ||
          selectedCard.textContent
        )
      : null;

    const actualWeight = actualVariant
      ? weightFromText(
          actualVariant.option1 || actualVariant.title
        )
      : null;

    return {
      actualId,
      actualWeight,
      visibleWeight,
      hasVariant: !!actualVariant,
      hasData: variants.length > 0
    };
  }

  function isPreorder(selection) { return preorderForId(selection.actualId)?.preorder === true; }

  function getForm(target) {
    const productForm = target.closest("product-form");
    if (!productForm) return null;

    return productForm.querySelector(
      'form[data-type="add-to-cart-form"]'
    );
  }

  function isXdbReady() {
    return !!getModal() && getVariants().length > 0;
  }

  function updateModalDispatch(modal, dispatch) {
    const p = modal?.querySelector('.xdb-preorder-dispatch');
    if (p) p.textContent = 'Estimated dispatch: ' + (dispatch || 'To be confirmed') + '.';
  }

  function openModal(form, variantId) {
    const modal = getModal();

    if (!modal) {
      console.error("XDB: Modal missing");
      return;
    }

    updateModalDispatch(modal, preorderForId(variantId)?.dispatch);
    pendingForm = form;
    pendingId = variantId;
    previousFocus = document.activeElement;
    oldOverflow = document.body.style.overflow;

    modal.hidden = false;
    document.body.style.overflow = "hidden";

    modal.querySelector(".xdb-preorder-dialog")?.focus();
  }

  function closeModal() {
    const modal = getModal();
    if (modal) modal.hidden = true;

    document.body.style.overflow = oldOverflow;

    pendingForm = null;
    pendingId = null;

    if (previousFocus?.isConnected) {
      previousFocus.focus();
    }
  }

  function intercept(event, form) {
    if (approvedForm === form) return;

    const selection = getSelection(form);

    const preorderSelected =
      isPreorder(selection);

    const clear20kg =
      selection.hasVariant &&
      !preorderSelected &&
      (
        selection.visibleWeight === selection.actualWeight ||
        selection.visibleWeight === null
      );

    // Let any verified non-preorder variant use the normal cart flow.
    if (clear20kg) { form.querySelector('input[name="properties[Estimated dispatch]"]')?.remove(); return; }

    // Anything else on XDB must be checked before adding.
    event.preventDefault();
    event.stopImmediatePropagation();

    if (!isXdbReady()) {
      console.error("XDB: Modal or variant data missing");
      alert(
        "We could not verify this product option. Please refresh the page and try again."
      );
      return;
    }

    if (!selection.hasVariant || !selection.actualId) {
      alert(
        "Please select a valid product option before adding to cart."
      );
      return;
    }

    if (
      selection.visibleWeight !== null &&
      selection.visibleWeight !== selection.actualWeight
    ) {
      alert(
        "Your selected option has not updated correctly. Please select it again."
      );
      return;
    }

    if (!preorderSelected) {
      alert(
        "Please check your selected product option."
      );
      return;
    }

    if (!pendingForm) {
      openModal(form, selection.actualId);
    }
  }

  // Block the button click before theme click handlers.
  document.addEventListener("click", event => {
    const button = event.target.closest(
      'product-form button[type="submit"][name="add"]'
    );

    if (!button) return;

    const form = getForm(button);
    if (!form) return;

    intercept(event, form);
  }, true);

  // Also block keyboard submission and other submit paths.
  document.addEventListener("submit", event => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches('form[data-type="add-to-cart-form"]') ||
      !form.closest("product-form")
    ) {
      return;
    }

    intercept(event, form);
  }, true);

  // Modal interactions.
  document.addEventListener("click", event => {
    const modal = getModal();
    if (!modal || modal.hidden) return;

    if (
      event.target === modal ||
      event.target.closest(".xdb-preorder-close") ||
      event.target.closest(".xdb-preorder-cancel")
    ) {
      closeModal();
      return;
    }

    const confirm = event.target.closest(
      ".xdb-preorder-confirm"
    );

    if (!confirm || !modal.contains(confirm)) return;

    const form = pendingForm;

    if (!form || !form.isConnected) {
      closeModal();
      return;
    }

    const selection = getSelection(form);

    if (
      selection.actualId !== pendingId ||
      !isPreorder(selection) ||
      (
        selection.visibleWeight !== null &&
        selection.visibleWeight !== selection.actualWeight
      )
    ) {
      closeModal();
      alert(
        "Your selected option has changed. Please try again."
      );
      return;
    }

    confirm.disabled = true;

    modal.hidden = true;
    document.body.style.overflow = oldOverflow;

    const dispatch = preorderForId(selection.actualId)?.dispatch || 'To be confirmed';
    let property = form.querySelector('input[name="properties[Estimated dispatch]"]');
    if (!property) { property = document.createElement('input'); property.type = 'hidden'; property.name = 'properties[Estimated dispatch]'; form.appendChild(property); }
    property.value = dispatch;
    approvedForm = form;

    try {
      // Submit using Glozin's native add-to-cart handler.
      form.requestSubmit();
    } finally {
      approvedForm = null;
      pendingForm = null;
      pendingId = null;
      confirm.disabled = false;
    }
  });

  document.addEventListener("keydown", event => {
    const modal = getModal();
    if (!modal || modal.hidden) return;

    if (event.key === "Escape") {
      event.preventDefault();
      closeModal();
    }
  });

  console.info("AMONAX XDB Pre-order v3 loaded");
})();

/* XDB: Dynamic Add to Cart / Pre-Order Now button label */
(() => {
  if (window.__xdbButtonLabelInstalled) return;
  window.__xdbButtonLabelInstalled = true;

  function updateXdbButton() {
    const selectedCard = document.querySelector(
      '.amonax-db-weight-card[aria-pressed="true"]'
    );

    if (!selectedCard) return;

    const weight = (
      selectedCard.dataset.weight ||
      selectedCard.textContent ||
      ""
    ).toUpperCase();

    let configs = [];
    try { configs = JSON.parse(document.querySelector('[id^="xdb-preorder-config-"]')?.textContent || '[]'); } catch {}
    const variant = configs.find(v => String(v.id) === String(document.querySelector('product-form form[data-type="add-to-cart-form"] input[name="id"]')?.value));
    const isPreorder = variant?.preorder === true;

    const productRoot = selectedCard.closest(
      '[id^="MainProduct-"]'
    );

    if (!productRoot) return;

    const button = productRoot.querySelector(
      '.product-detail__buy-buttons .product-form__submit'
    );

    if (!button) return;

    const label = button.querySelector(".btn-label");

    if (!label) return;

    const newText = isPreorder
      ? "Pre-Order Now"
      : "Add to Cart";

    if (label.textContent.trim() !== newText) {
      label.textContent = newText;
    }
  }

  document.addEventListener("click", event => {
    if (event.target.closest(".amonax-db-weight-card")) {
      setTimeout(updateXdbButton, 0);
      setTimeout(updateXdbButton, 150);
    }
  });

  document.addEventListener("variant:change", () => {
    setTimeout(updateXdbButton, 0);
    setTimeout(updateXdbButton, 150);
  });

  document.addEventListener("shopify:section:load", () => {
    setTimeout(updateXdbButton, 150);
  });

  const observer = new MutationObserver(updateXdbButton);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["aria-pressed"]
  });

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      updateXdbButton,
      { once: true }
    );
  } else {
    updateXdbButton();
  }
})();


/* XDB: Show pre-order notice for 36KG / 45KG only */
(() => {
  if (window.__xdbNoticeInstalled) return;
  window.__xdbNoticeInstalled = true;

  function updateNotice() {
    const card = document.querySelector(
      '.amonax-db-weight-card[aria-pressed="true"]'
    );

    const notice = document.querySelector(
      '[id^="amonax-db-preorder-note-"]'
    );

    if (!card || !notice) return;

    const weight = (
      card.dataset.weight ||
      card.textContent ||
      ""
    );

    let configs = [];
    try { configs = JSON.parse(document.querySelector('[id^="xdb-preorder-config-"]')?.textContent || '[]'); } catch {}
    const variant = configs.find(v => String(v.id) === String(document.querySelector('product-form form[data-type="add-to-cart-form"] input[name="id"]')?.value));
    const isPreorder = variant?.preorder === true;
    const heading = notice.querySelector('strong');
if (heading && variant?.dispatch) {
  const nextText = 'PRE-ORDER — Estimated dispatch: ' + variant.dispatch;

  if (heading.textContent !== nextText) {
    heading.textContent = nextText;
  }
}
notice.style.display = isPreorder ? "flex" : "none";  }

  document.addEventListener("click", event => {
    if (event.target.closest(".amonax-db-weight-card")) {
      setTimeout(updateNotice, 0);
      setTimeout(updateNotice, 150);
    }
  });

  document.addEventListener("variant:change", updateNotice);

  document.addEventListener("shopify:section:load", () => {
    setTimeout(updateNotice, 150);
  });

  const observer = new MutationObserver(updateNotice);

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["aria-pressed"]
  });

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      updateNotice,
      { once: true }
    );
  } else {
    updateNotice();
  }
})();
